import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import classNames from 'clsx';

import { ReactComponent as AccountCircle } from 'app/assets/icons/account-circle.svg';
import { LabelEnum, RouteEnum } from 'app/shared/enums';
import { AppMenuButton } from 'app/components/AppMenuButton';
import { isFormSubmitting } from 'app/store/data/formSubmission';

import { LoginButtonProps } from './LoginButton.interfaces';
import { useStyles } from './LoginButton.styles';

export default function LoginButton({
  redirect,
  className,
  rounded,
  isInactive,
}: LoginButtonProps) {
  const classes = useStyles();
  const location = useLocation();
  const isLoading = useSelector(isFormSubmitting);

  const loginTarget = {
    pathname: isLoading ? undefined : RouteEnum.LOGIN,
    state: {
      modal: true,
      from: redirect,
      ...((location.pathname.startsWith(RouteEnum.CLAIM_BONUS) ||
        location.pathname.startsWith(RouteEnum.CALCULATION_RESULTS)) && {
        closeRedirect: location.pathname,
      }),
    },
  };

  return (
    <AppMenuButton
      to={isInactive ? undefined : loginTarget}
      icon={
        rounded ? (AccountCircle as ComponentType<SvgIconProps>) : undefined
      }
      variant={'outlined'}
      color={'primary'}
      title={LabelEnum.LogIn}
      className={classNames(className, {
        [classes.rounded]: rounded,
      })}
      data-cy="login"
    />
  );
}
